export default [
  {
    key: 'checkbox',
    label: '',
    _style: 'width:1%',
    sorter: false,
    filter: false,
    slot: true,
  },
  {
    label: 'メールアドレス',
    key: 'email',
    _style: 'min-width:200px',
  },
  { label: 'ユーザ名', key: 'account_name', _style: 'min-width:250px' },
  { label: 'デバイス名', key: 'device_name', _style: 'min-width:120px' },
  { label: '体重', key: 'weight', _style: 'min-width:75px', sorter: false },
  {
    label: '体脂肪率',
    key: 'body_fat_rate',
    _style: 'min-width:90px',
    sorter: false,
  },
  { label: 'BMI', key: 'BMI', _style: '', sorter: false },
  { label: 'アスリートモード', key: 'athlete', _style: '', sorter: false },
  { label: '計測日時', key: 'created_at', _style: '', slot: true },
]
